module.exports = __webpack_public_path__ + "static/media/home_portrait.0a6e5d11.png";